/* eslint react/forbid-prop-types: 0 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {propertyTypesMessages} from '../../../utils/property-types-messages';
import {FormattedMessage, injectIntl} from 'react-intl';
import sentenceCase from '../../../utils/sentence-case';
import {HeroImage} from './HeroImage';
import {SearchBoxLite} from '../../common/searchboxlite/SearchBoxLite';
import {isPropertyTypeAll} from '../../../utils/property-types';
import {wrapInTest} from '../../common/mvt/utils/mvt';
import {TESTS, getValue} from '../../../utils/abacus';

const messages = Object.assign({}, propertyTypesMessages);

export function mapStateToProps(state) {
    return {
        inventoryCount: state.destination.inventoryCount,
        details: state.destination.details,
        propertyType: state.destination.propertyType,
        defaultImage: state.destination.details.heroImageDefault,
        listings: state.destination.listings,
        abacus: state.abacus,
        deviceType: state.config.deviceType
    };
}

export class HeaderComponent extends Component {
    static propTypes = {
        details: PropTypes.shape({
            simpleName: PropTypes.string,
            fullName: PropTypes.string
        }),
        site: PropTypes.shape({
            domain: PropTypes.string
        }),
        inventoryCount: PropTypes.number,
        defaultImage: PropTypes.string,
        hideSubHeading: PropTypes.bool,
        headingOverride: PropTypes.string,
        resetForm: PropTypes.bool
    };

    static defaultProps = {
        site: {
            domain: 'www.homeaway.com'
        },
        inventoryCount: 0,
        hideSubHeading: false,
        headingOverride: null,
        resetForm: false
    };

    constructor(props) {
        super(props);
        this.state = {
            destinationFontSize: null
        };
    }

    componentDidMount() {
        if (window) {
            require('object-fit-images').default();
        }
    }

    getDestinationTitle(name, destinationFontSize) {
        return (
            <span
                ref="header-h1-strong"
                style={{fontSize: destinationFontSize}}
            >
                {`${name}`}
            </span>
        );
    }

    renderHeading() {
        const {
            details,
            propertyType,
            headingOverride,
            intl: {formatMessage}
        } = this.props;

        const propertyTypePlural = formatMessage(messages[`${propertyType}`]);
        const propertyTypeSingularlWithArticle = formatMessage(
            messages[`${propertyType}_singular_with_article`]
        );
        const propertyTypePage = !isPropertyTypeAll(propertyType);
        const destinationFontSize = this.state.destinationFontSize;
        const destinationName = this.getDestinationTitle(
            details.simpleName,
            destinationFontSize
        );
        const destinationHierarchy = this.getDestinationTitle(
            details.fullName,
            destinationFontSize
        );

        let headingContent;
        if (headingOverride) {
            headingContent = headingOverride;
        } else if (!propertyTypePage) {
            headingContent = destinationHierarchy;
        } else {
            headingContent = (
                <FormattedMessage
                    id="searchForm.title"
                    defaultMessage="UNTRANSLATED"
                    values={{
                        destinationName,
                        destinationHierarchy,
                        propertyTypePluralNoArticle: sentenceCase(
                            propertyTypePlural
                        ),
                        propertyTypeSingularlWithArticle
                    }}
                />
            );
        }

        return (
            <div className="main-heading">
                <h1 ref="header-h1">{headingContent}</h1>
            </div>
        );
    }

    render() {
        const {
            details,
            inventoryCount,
            propertyType,
            hideSubHeading,
            intl: {formatNumber, formatMessage},
            listings,
            abacus,
            deviceType
        } = this.props;
        const isMobile = (deviceType === 'mobile');

        const propertyTypePlural = formatMessage(messages[`${propertyType}`]);
        const propertyTypeSingularlWithArticle = formatMessage(
            messages[`${propertyType}_singular_with_article`]
        );

        const subheading = (
            <FormattedMessage
                id="searchForm.subheading.found"
                defaultMessage="UNTRANSLATED"
                values={{
                    propertyTypePluralNoArticle: propertyTypePlural,
                    propertyTypeSingularlWithArticle,
                    count: inventoryCount,
                    inventoryCount: formatNumber(inventoryCount)
                }}
            />);

        const showTest = getValue(abacus, TESTS.SLP_2194V) === 1;

        const haHeader = (
            <div className={`${showTest ? ' expanded-searchbox' : ''}`}>
                <div className="ha-header">
                    <HeroImage
                        urlTemplate={details.heroImageTemplate}
                        defaultImage={this.props.defaultImage}
                        altText={details.fullName}
                        showTest={showTest}
                    />
                    <div className="jumbotron">
                        <div className="heading">
                            {this.renderHeading()}
                            {(!hideSubHeading && listings.length !== 0) && (
                                <h2>
                                    {subheading}
                                </h2>
                            )}
                        </div>
                        <SearchBoxLite resetForm={this.props.resetForm} {...{isMobile}} />
                    </div>
                </div>
            </div>
        );
        return wrapInTest(abacus, TESTS.SLP_2194V, haHeader);
    }
}

export const Header = injectIntl(connect(mapStateToProps)(HeaderComponent));
export default Header;
